(() => {
  'use strict';

  const HERO_SELECTOR = '[data-fb-hero-story]';
  const PROOF_SELECTOR = '[data-fb-proof-carousel]';
  const INDEX_SELECTOR = '[data-fb-index]';

  const ROUTE_RESULTS_ES = {
    serena: {
      title: 'SERENA · Calma y equilibrio',
      text: 'Encaja cuando la prioridad es bajar revoluciones durante el día sin buscar un efecto sedante. El pack aporta un eje adaptogénico y otro mineral; los productos individuales permiten empezar por una sola pieza.',
      urlKey: 'serenaUrl'
    },
    placida: {
      title: 'NŌCTIA · Descanso profundo',
      text: 'Encaja cuando la dificultad se concentra en la desconexión nocturna, la conciliación o un descanso poco reparador. La selección reúne relajación mental y soporte nutricional.',
      urlKey: 'placidaUrl'
    },
    lucidia: {
      title: 'CŌGNIA · Claridad mental',
      text: 'Encaja cuando necesitas sostener atención y energía mental sin añadir más activación. La arquitectura combina soporte energético celular con foco relajado.',
      urlKey: 'lucidiaUrl'
    },
    vitae: {
      title: 'GIA+ · Energía y vitalidad',
      text: 'Encaja cuando la señal principal es la falta de energía física o la caída de rendimiento. La propuesta se centra en energía celular y capacidad para sostener el esfuerzo.',
      urlKey: 'vitaeUrl'
    },
    structa: {
      title: 'OSTEO · Movimiento y estructura',
      text: 'Encaja cuando priorizas movilidad, músculo, recuperación o autonomía. La selección conecta soporte estructural y función neuromuscular.',
      urlKey: 'structaUrl'
    },
    nova: {
      title: 'VĪTAE · Longevidad celular',
      text: 'Encaja cuando buscas preservar vitalidad y autonomía a largo plazo. La arquitectura combina apoyo mitocondrial y protección antioxidante.',
      urlKey: 'novaUrl'
    }
  };

  const ROUTE_RESULTS_EN = {
    serena: {
      title: 'SERENA · Calm and balance',
      text: 'A fit when the priority is to lower daytime tension without seeking a sedative effect. The pack combines an adaptogenic axis with nutritional support; individual products let you start with one component.',
      urlKey: 'serenaUrl'
    },
    placida: {
      title: 'NŌCTIA · Deep rest',
      text: 'A fit when the difficulty centres on unwinding at night, falling asleep or restorative rest. The selection brings together mental relaxation and nutritional support.',
      urlKey: 'placidaUrl'
    },
    lucidia: {
      title: 'CŌGNIA · Mental clarity',
      text: 'A fit when you want to sustain attention and mental energy without adding more stimulation. Its structure combines cellular energy support with relaxed focus.',
      urlKey: 'lucidiaUrl'
    },
    vitae: {
      title: 'GIA+ · Energy and vitality',
      text: 'A fit when the main signal is low physical energy or inconsistent performance. The proposal centres on cellular energy and the ability to sustain effort.',
      urlKey: 'vitaeUrl'
    },
    structa: {
      title: 'OSTEO · Movement and structure',
      text: 'A fit when mobility, muscle, recovery or autonomy are the priority. The selection connects structural support with neuromuscular function.',
      urlKey: 'structaUrl'
    },
    nova: {
      title: 'VĪTAE · Cellular longevity',
      text: 'A fit when you want to preserve vitality and autonomy over time. Its structure combines mitochondrial support and antioxidant protection.',
      urlKey: 'novaUrl'
    }
  };

  const INDEX_QUESTIONS_ES = [
    {
      question: '¿Qué está limitando más tu bienestar?',
      hint: 'Elige la señal que ocupa más espacio ahora, aunque reconozcas varias.',
      options: [
        {
          label: 'Me cuesta desconectar',
          detail: 'Tensión, rumiación, calma o descanso',
          scores: { serena: 4, placida: 2 }
        },
        {
          label: 'Me falta energía o claridad',
          detail: 'Cansancio, niebla mental o rendimiento irregular',
          scores: { vitae: 3, lucidia: 3, nova: 1 }
        },
        {
          label: 'Quiero cuidar cuerpo y futuro',
          detail: 'Movimiento, estructura, autonomía o longevidad',
          scores: { structa: 2, nova: 4, vitae: 1 }
        }
      ]
    },
    {
      question: '¿Cuándo lo notas con más claridad?',
      hint: 'El momento en que aparece ayuda a distinguir necesidades que pueden parecer iguales.',
      options: [
        {
          label: 'Al llegar la noche',
          detail: 'Me cuesta frenar, conciliar o descansar bien',
          scores: { placida: 5, serena: 1 }
        },
        {
          label: 'Durante trabajo o estudio',
          detail: 'Pierdo foco, claridad o energía mental',
          scores: { lucidia: 5, vitae: 1 }
        },
        {
          label: 'Al moverme o entrenar',
          detail: 'Noto fatiga, rigidez o recuperación lenta',
          scores: { structa: 4, vitae: 3, nova: 1 }
        }
      ]
    },
    {
      question: '¿Qué cambio quieres notar primero?',
      hint: 'Priorizar un primer cambio evita acumular productos sin un objetivo claro.',
      options: [
        {
          label: 'Calma funcional durante el día',
          detail: 'Sentirme más regulado sin desconectarme',
          scores: { serena: 5, placida: 1 }
        },
        {
          label: 'Energía física más sostenida',
          detail: 'Llegar al final del día o del esfuerzo con más continuidad',
          scores: { vitae: 5, structa: 1 }
        },
        {
          label: 'Vitalidad para los próximos años',
          detail: 'Cuidar energía celular, movimiento y autonomía',
          scores: { nova: 6, structa: 1 }
        }
      ]
    },
    {
      question: '¿Qué resultado te haría sentir que vas por buen camino?',
      hint: 'Esta respuesta termina de ponderar la ruta y separa el pack de los productos individuales.',
      options: [
        {
          label: 'Dormir y desconectar mejor',
          detail: 'Una noche más regular y una llegada a la cama más tranquila',
          scores: { placida: 5, serena: 1 }
        },
        {
          label: 'Pensar y rendir con claridad',
          detail: 'Atención más estable y menos niebla mental',
          scores: { lucidia: 5, vitae: 1 }
        },
        {
          label: 'Moverme con más confianza',
          detail: 'Mejor continuidad física, recuperación y autonomía',
          scores: { structa: 4, nova: 2 }
        }
      ]
    }
  ];

  const INDEX_QUESTIONS_EN = [
    {
      question: 'What is limiting your wellbeing most?',
      hint: 'Choose the signal taking up the most space now, even if several apply.',
      options: [
        {
          label: 'I find it difficult to switch off',
          detail: 'Tension, overthinking, calm or sleep',
          scores: { serena: 4, placida: 2 }
        },
        {
          label: 'I lack energy or clarity',
          detail: 'Fatigue, brain fog or inconsistent performance',
          scores: { vitae: 3, lucidia: 3, nova: 1 }
        },
        {
          label: 'I want to support body and future',
          detail: 'Movement, structure, autonomy or longevity',
          scores: { structa: 2, nova: 4, vitae: 1 }
        }
      ]
    },
    {
      question: 'When do you notice it most clearly?',
      hint: 'Timing helps distinguish needs that can otherwise feel similar.',
      options: [
        {
          label: 'Towards the evening',
          detail: 'I struggle to slow down, fall asleep or rest well',
          scores: { placida: 5, serena: 1 }
        },
        {
          label: 'While working or studying',
          detail: 'I lose focus, clarity or mental energy',
          scores: { lucidia: 5, vitae: 1 }
        },
        {
          label: 'When moving or training',
          detail: 'I notice fatigue, stiffness or slow recovery',
          scores: { structa: 4, vitae: 3, nova: 1 }
        }
      ]
    },
    {
      question: 'What change would you like to notice first?',
      hint: 'Prioritising one initial change helps avoid accumulating products without a clear goal.',
      options: [
        {
          label: 'Functional calm during the day',
          detail: 'Feeling more regulated without switching off',
          scores: { serena: 5, placida: 1 }
        },
        {
          label: 'More sustained physical energy',
          detail: 'Reaching the end of the day or effort with greater continuity',
          scores: { vitae: 5, structa: 1 }
        },
        {
          label: 'Vitality for the years ahead',
          detail: 'Supporting cellular energy, movement and autonomy',
          scores: { nova: 6, structa: 1 }
        }
      ]
    },
    {
      question: 'What outcome would show that you are on the right track?',
      hint: 'This final answer refines the score and separates the pack from individual products.',
      options: [
        {
          label: 'Sleep and unwind more easily',
          detail: 'A more regular night and a calmer transition to bed',
          scores: { placida: 5, serena: 1 }
        },
        {
          label: 'Think and perform with clarity',
          detail: 'More stable attention and less brain fog',
          scores: { lucidia: 5, vitae: 1 }
        },
        {
          label: 'Move with greater confidence',
          detail: 'Better physical continuity, recovery and autonomy',
          scores: { structa: 4, nova: 2 }
        }
      ]
    }
  ];

  function initialiseHero(root) {
    if (root.dataset.fbHeroReady === 'true') return;

    const slides = [...root.querySelectorAll('[data-fb-hero-slide]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Number(root.dataset.fbHeroInterval) || 5000;
    let activeIndex = 0;
    let timer = null;

    if (slides.length < 2) return;
    root.dataset.fbHeroReady = 'true';

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener?.('change', start);

    showSlide(0);
    start();
  }

  function initialiseProofCarousel(root) {
    if (root.dataset.fbProofReady === 'true') return;

    const track = root.querySelector('[data-fb-proof-track]');
    const slides = [...root.querySelectorAll('[data-fb-proof-slide]')];
    const status = root.querySelector('[data-fb-proof-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Number(root.dataset.fbProofInterval) || 3400;
    let activeIndex = 0;
    let timer = null;

    if (!track || slides.length < 2) return;
    root.dataset.fbProofReady = 'true';

    const showSlide = (index, announce = false) => {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      if (announce && status) {
        const isEnglish = document.documentElement.lang?.toLowerCase().startsWith('en');
        status.textContent = isEnglish
          ? `Standard ${activeIndex + 1} of ${slides.length}`
          : `Criterio ${activeIndex + 1} de ${slides.length}`;
      }
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener?.('change', start);

    showSlide(0);
    start();
  }

  function initialiseIndex(root) {
    if (root.dataset.fbIndexReady === 'true') return;

    const questionView = root.querySelector('[data-fb-question-view]');
    const question = root.querySelector('[data-fb-question]');
    const questionHint = root.querySelector('[data-fb-question-hint]');
    const questionNumber = root.querySelector('[data-fb-question-number]');
    const progressSegments = [...root.querySelectorAll('[data-fb-progress-segment]')];
    const answers = root.querySelector('[data-fb-answers]');
    const trail = root.querySelector('[data-fb-route-trail]');
    const backButton = root.querySelector('[data-fb-route-back]');
    const resetButton = root.querySelector('[data-fb-route-reset]');
    const status = root.querySelector('[data-fb-route-status]');
    const result = root.querySelector('[data-fb-result]');
    const resultTitle = root.querySelector('[data-fb-result-title]');
    const resultText = root.querySelector('[data-fb-result-text]');
    const resultConfidence = root.querySelector('[data-fb-result-confidence]');
    const resultReasons = root.querySelector('[data-fb-result-reasons]');
    const resultLink = root.querySelector('[data-fb-result-link]');
    const resultRestart = root.querySelector('[data-fb-result-restart]');
    const resultGroups = [...root.querySelectorAll('[data-fb-result-group]')];
    const reportGate = root.querySelector('[data-fb-report-gate]');
    const reportContent = root.querySelector('[data-fb-report-content]');
    const reportForm = root.querySelector('.fb-index__report-form');
    const reportTags = root.querySelector('[data-fb-report-tags]');
    const reportSuccess = root.querySelector('[data-fb-report-success]');
    const isEnglish = root.dataset.fbLocale?.toLowerCase().startsWith('en');
    const routeResults = isEnglish ? ROUTE_RESULTS_EN : ROUTE_RESULTS_ES;
    const indexQuestions = isEnglish ? INDEX_QUESTIONS_EN : INDEX_QUESTIONS_ES;
    const storageKey = 'fitobotanic-index-report-v2';
    const unlockKey = 'fitobotanic-index-report-unlocked-v2';
    const strings = isEnglish
      ? {
          start: 'Start',
          question: 'Question',
          of: 'of',
          result: 'Result',
          reset: 'Assessment reset.',
          confidenceHigh: 'High affinity: your answers converge clearly on this route.',
          confidenceDefined: 'Defined affinity: this route has the most consistent score.',
          confidenceShared: 'Shared affinity: this is the first route to explore, but compare the second option too.'
        }
      : {
          start: 'Inicio',
          question: 'Pregunta',
          of: 'de',
          result: 'Resultado',
          reset: 'Test reiniciado.',
          confidenceHigh: 'Afinidad alta: tus respuestas convergen con claridad en esta ruta.',
          confidenceDefined: 'Afinidad definida: esta ruta obtiene la puntuación más consistente.',
          confidenceShared: 'Afinidad compartida: esta es la primera ruta a explorar, pero conviene comparar la segunda opción.'
        };

    if (!questionView || !question || !answers || !result || !resultLink) return;
    root.dataset.fbIndexReady = 'true';

    const state = {
      questionIndex: 0,
      selections: []
    };

    const renderTrail = () => {
      if (!trail) return;
      trail.replaceChildren();
      const labels = [strings.start, ...state.selections.map((selection) => selection.label)];
      labels.forEach((label, index) => {
        const item = document.createElement('li');
        item.textContent = label;
        if (index === labels.length - 1) item.classList.add('is-current');
        trail.append(item);
      });
      trail.scrollLeft = trail.scrollWidth;
    };

    const calculateResult = () => {
      const totals = Object.keys(routeResults).reduce((scores, key) => {
        scores[key] = 0;
        return scores;
      }, {});

      state.selections.forEach((selection) => {
        Object.entries(selection.scores).forEach(([key, value]) => {
          totals[key] += value;
        });
      });

      const ranking = Object.entries(totals).sort((left, right) => right[1] - left[1]);
      return {
        key: ranking[0][0],
        topScore: ranking[0][1],
        difference: ranking[0][1] - ranking[1][1]
      };
    };

    const createAnswer = (option) => {
      const button = document.createElement('button');
      const title = document.createElement('strong');
      const detail = document.createElement('small');
      const arrow = document.createElement('span');

      button.type = 'button';
      button.className = 'fb-index-answer';
      title.textContent = option.label;
      detail.textContent = option.detail;
      arrow.className = 'fb-index-answer__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      button.append(title, detail, arrow);

      button.addEventListener('click', () => {
        state.selections[state.questionIndex] = option;
        state.selections = state.selections.slice(0, state.questionIndex + 1);

        if (state.questionIndex < indexQuestions.length - 1) {
          state.questionIndex += 1;
          renderQuestion(true);
        } else {
          renderResult();
        }
      });

      return button;
    };

    const renderQuestion = (shouldFocus = false) => {
      const current = indexQuestions[state.questionIndex];
      questionView.hidden = false;
      result.hidden = true;
      question.textContent = current.question;
      questionHint.textContent = current.hint;
      questionNumber.textContent = String(state.questionIndex + 1);
      answers.replaceChildren(...current.options.map(createAnswer));
      backButton.hidden = state.questionIndex === 0;
      progressSegments.forEach((segment, index) => {
        segment.classList.toggle('is-active', index <= state.questionIndex);
      });
      renderTrail();

      if (status) {
        status.textContent = `${strings.question} ${state.questionIndex + 1} ${strings.of} 4: ${current.question}`;
      }
      if (shouldFocus) question.focus?.({ preventScroll: true });
    };

    const renderResult = () => {
      const calculated = calculateResult();
      const route = routeResults[calculated.key];
      const list = document.createElement('ul');

      state.selections.forEach((selection) => {
        const item = document.createElement('li');
        item.textContent = selection.label;
        list.append(item);
      });

      questionView.hidden = true;
      result.hidden = false;
      resultTitle.textContent = route.title;
      resultText.textContent = route.text;
      resultConfidence.textContent =
        calculated.difference >= 5
          ? strings.confidenceHigh
          : calculated.difference >= 2
            ? strings.confidenceDefined
            : strings.confidenceShared;
      resultReasons.replaceChildren(list);
      resultLink.href = root.dataset[route.urlKey] || '/collections/packs-fitobotanic';
      resultGroups.forEach((group) => {
        group.hidden = group.dataset.fbResultGroup !== calculated.key;
      });
      if (reportTags) {
        reportTags.value = `fitobotanic-index,personalized-report,fitobotanic-index-${calculated.key}`;
      }
      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            questionIndex: state.questionIndex,
            selections: state.selections,
            result: calculated.key
          })
        );
      } catch (_error) {
        // Storage may be unavailable in privacy-restricted browsers.
      }

      let reportUnlocked = Boolean(reportSuccess);
      try {
        reportUnlocked = reportUnlocked || window.localStorage.getItem(unlockKey) === 'true';
        if (reportSuccess) window.localStorage.setItem(unlockKey, 'true');
      } catch (_error) {
        // Server-confirmed success still unlocks the report without storage.
      }
      if (reportGate) reportGate.hidden = reportUnlocked;
      if (reportContent) reportContent.hidden = !reportUnlocked;
      backButton.hidden = false;
      renderTrail();

      if (status) status.textContent = `${strings.result}: ${route.title}.`;
      resultTitle.setAttribute('tabindex', '-1');
      if (reportUnlocked) {
        resultTitle.focus({ preventScroll: true });
      } else {
        reportGate?.querySelector('h3')?.focus?.({ preventScroll: true });
      }

      document.dispatchEvent(
        new CustomEvent('fitobotanic:route-completed', {
          detail: {
            result: calculated.key,
            answers: state.selections.map((selection) => selection.label)
          }
        })
      );
    };

    const goBack = () => {
      if (result.hidden === false) {
        state.questionIndex = indexQuestions.length - 1;
        state.selections = state.selections.slice(0, -1);
        renderQuestion(true);
        return;
      }
      if (state.questionIndex === 0) return;
      state.questionIndex -= 1;
      state.selections = state.selections.slice(0, state.questionIndex);
      renderQuestion(true);
    };

    const reset = () => {
      state.questionIndex = 0;
      state.selections = [];
      resultGroups.forEach((group) => {
        group.hidden = true;
      });
      renderQuestion(true);
      if (status) status.textContent = strings.reset;
    };

    reportForm?.addEventListener('submit', () => {
      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({ questionIndex: state.questionIndex, selections: state.selections })
        );
      } catch (_error) {
        // Native Shopify form submission remains functional.
      }
    });

    backButton?.addEventListener('click', goBack);
    resetButton?.addEventListener('click', reset);
    resultRestart?.addEventListener('click', reset);
    let savedState = null;
    try {
      savedState = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    } catch (_error) {
      savedState = null;
    }
    if (reportSuccess && savedState?.selections?.length === indexQuestions.length) {
      state.questionIndex = indexQuestions.length - 1;
      state.selections = savedState.selections;
      renderResult();
    } else {
      renderQuestion();
    }
  }

  function initialiseSmoothAnchors() {
    if (document.documentElement.dataset.fbSmoothAnchors === 'true') return;
    document.documentElement.dataset.fbSmoothAnchors = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || link.getAttribute('href') === '#') return;

      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  }

  function initialise(scope = document) {
    scope.querySelectorAll(HERO_SELECTOR).forEach(initialiseHero);
    scope.querySelectorAll(PROOF_SELECTOR).forEach(initialiseProofCarousel);
    scope.querySelectorAll(INDEX_SELECTOR).forEach(initialiseIndex);
    initialiseSmoothAnchors();
  }

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
